import axios from 'axios';

function getGroups() {
    return axios.get('notify-baja-da');
}

function getByGroup(keyGroup) {
    return axios.get(`notify-baja-da/${keyGroup}`);
}

function createGroup(records) {
    return axios.post('notify-baja-da', { records });
}

function createRegistro(data) {
    return axios.post('notify-baja-da/registro', data);
}

function updateRegistro(id, data) {
    return axios.put(`notify-baja-da/registro/${id}`, data);
}

function deleteRegistro(id) {
    return axios.delete(`notify-baja-da/registro/${id}`);
}

function deleteGroup(keyGroup) {
    return axios.delete(`notify-baja-da/${keyGroup}`);
}

function iniciarProceso(keyGroup) {
    return axios.post(`notify-baja-da/${keyGroup}/iniciar`);
}

const NotifyBajaDA = {
    getGroups,
    getByGroup,
    createGroup,
    createRegistro,
    updateRegistro,
    deleteRegistro,
    deleteGroup,
    iniciarProceso
};

export default NotifyBajaDA;
